import React, { useContext, useEffect, useState } from "react";
import { useDrop } from "react-dnd";
import { DraggingAnswer, BotoxJarType, DropPointProps } from "../utils/types";
import SuccessAudio from "../assets/sounds/success.mp3";
import WrongAudio from "../assets/sounds/wrong.mp3";
import { ACTIONS, useScore } from "../utils/constants";

export default function DropPoint({
  onDrop,
  correctAnswer,
  top,
  left,
  bottom,
  right,
}: DropPointProps) {
  const { dispatch: updateScore } = useScore();

  const [collectedProps, drop] = useDrop(() => ({
    accept: BotoxJarType,
    drop: (droppedItem: DraggingAnswer) => {
      if (droppedItem.value === correctAnswer) {
        onDrop(droppedItem.value);
        new Audio(SuccessAudio).play();
        updateScore({ type: ACTIONS.INCREAMEANT_SCORE, payload: 5 });
      } else {
        new Audio(WrongAudio).play();
        updateScore({ type: ACTIONS.DECREAMEANT_SCORE, payload: 1 });
      }
    },
  }));


  return (
    <section
      className={`drop-target `}
      ref={drop}
      style={{ top, left, right, bottom }}
    >
      <span></span>
    </section>
  );
}
